import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'

import { queryKeys } from '../../../../config/queryKeys'
import { getPlayerProgressSports } from '../../../../services/player/playerProgress'
import type { ProgressSport } from '../types'

/** Sports the player has progress for — the source of the sport chips. */
export const usePlayerProgressSports = (
  playerId?: string
): UseQueryResult<ProgressSport[], Error> => {
  'use memo'

  return useQuery({
    queryKey: queryKeys.playerStats.progressSports(playerId),
    queryFn: () => getPlayerProgressSports(playerId as string),
    enabled: Boolean(playerId),
  })
}

export default usePlayerProgressSports
